import { useEffect } from 'react';
import shallow from 'zustand/shallow';

import useErrorPaywall from './useErrorPaywall';
import useStore from './index';

import { TPaywallFeature, SectionEnum } from '../types';
import {
  PaywallFeatureEnum as PAYWALL,
  CompanyStreamWidget,
} from '../constants';

function useCompany(activeTab: string, symbol: string) {
  const { getStatus, addCounter } = useStore(
    (state) => ({
      getStatus: state.getStatus,
      addCounter: state.addCounter,
    }),
    shallow,
  );

  useErrorPaywall(activeTab, symbol);

  const getFeatureByKey = (key: string): TPaywallFeature | undefined => {
    const KEY = key.toUpperCase();
    return PAYWALL[KEY];
  };

  const companyGetStatus = (key: string): void => {
    const feature = getFeatureByKey(key);
    if (!feature) return;

    getStatus({ key: SectionEnum.company, feature, company: symbol });

    addCounter({ feature, company: symbol });
  };

  const companyAddCounter = (key: string): void => {
    const feature = getFeatureByKey(key);
    if (!feature) return;

    addCounter({ feature, company: symbol });
  };

  const getWidgetStatus = (): void => {
    const features = [PAYWALL.ORDERBOOK, PAYWALL.RUNNING_TRADE];
    getStatus({
      key: SectionEnum.company,
      feature: features,
      company: symbol,
    });

    // add counter for orderbook and running trade stream widget
    CompanyStreamWidget.forEach((key) => companyAddCounter(key));
  };

  useEffect(() => {
    if (!symbol) return;

    // undefined means the current tab is the stream tab
    if (activeTab === undefined) {
      getWidgetStatus();
      return;
    }

    if (!activeTab) return;

    companyGetStatus(activeTab);
  }, [activeTab, symbol]);

  return {
    addCounter: (key: string) => companyAddCounter(key),
  };
}

export default useCompany;
